import { isString } from "./utils/utility-functions.js";
export function createEnv(env, keys, partialKeys = []) {
    const result = {};
    for (const key of keys) {
        const value = env[key];
        if (isString(value)) {
            result[key] = value;
        }
        else {
            throw new Error(`Missing environment variable: ${key}`);
        }
    }
    for (const key of partialKeys) {
        const value = env[key];
        if (isString(value)) {
            result[key] = value;
        }
    }
    return result;
}
//# sourceMappingURL=createEnv.js.map